/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, func, string } from 'prop-types';

// Material UI
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { calendarColorStyle } from '../../../Helpers/Style-Helper';

const useStyles = makeStyles(
    () => ({
        root: {
            margin: 0,
        },
        forceExactDayRoot: {
            margin: 0,
            padding: '8px 0',
            width: '100%',
        },
        labelExactDay: {
            padding: '0 0 0 8px',
            fontSize: '0.875em !important',
        },
        checkbox: {
            fontSize: '1em',
            width: '20px',
            height: '20px',
            padding: '0',
            borderRadius: '2px',
            border: `1px solid ${calendarColorStyle.primary?.main}`,
            overflow: 'hidden',
            margin: '0',
            backgroundColor: 'white',
            '& svg': {
                maxWidth: '24px',
                fontSize: '24px',
                color: 'transparent',
            },
            '&$checkboxDisabled svg': {
                color: 'transparent',
                backgroundColor: 'white',
            },
        },
        checkboxChecked: {
            fontSize: '1em',
            width: '20px',
            height: '20px',
            padding: '0',
            borderRadius: '2px',
            margin: '0',
            border: `1px solid ${calendarColorStyle.primary?.main}`,
            overflow: 'hidden',
            '& svg': {
                maxWidth: '25px',
                fontSize: '25px',
                color: calendarColorStyle.common?.default,
                backgroundColor: calendarColorStyle.primary?.main,
            },
            '&$checkboxDisabled svg': {
                color: calendarColorStyle.common?.default,
                backgroundColor: calendarColorStyle.primary[200],
            },
        },
        checkboxDisabled: {
            border: `1px solid ${calendarColorStyle.primary[200]}`,
        },
    }),
    { name: 'ExactDay' },
);
const ExactDay = ({
    calendarDateType,
    forceExactDay,
    guaranteedCharge,
    handleForceExactDay,
}) => {
    const classes = useStyles();

    const showForceDelivery = (
        calendarDateType === 'between'
        && guaranteedCharge && guaranteedCharge !== 'null'
    );

    return (
        <Grid id="exact-day" container className={classes.root}>
            <FormControlLabel
                disabled={!showForceDelivery}
                className={classes.forceExactDayRoot}
                control={(
                    <Checkbox
                        checked={forceExactDay}
                        value="exactDayDelivery"
                        color="primary"
                        disabled={!showForceDelivery}
                        onChange={handleForceExactDay}
                        classes={{
                            root: classes.checkbox,
                            checked: classes.checkboxChecked,
                            disabled: classes.checkboxDisabled,
                        }}
                    />
                )}
                classes={{
                    label: classes.labelExactDay,
                }}
                label="Exact Day Delivery"
            />
        </Grid>
    );
};

ExactDay.propTypes = {
    calendarDateType: string,
    forceExactDay: bool.isRequired,
    guaranteedCharge: string,
    handleForceExactDay: func.isRequired,
};

ExactDay.defaultProps = {
    guaranteedCharge: null,
    calendarDateType: null,
};

export default ExactDay;
